<template>
	<div class="match-color-detail">
		<div class="w-w-full">
			<div class="ability-detail-body-title" style="">{{ filterBody }}</div>
			<div _flex="~ wrap">
				<div class="ability-detail-resource w-ml-10px" v-for="(item, index) in srcResource" :key="index">
					<audio
						class="ability-detail-audio"
						controls
						:src="item.src"
						v-if="item.type === 'audio'"
						controlslist="noplaybackrate nodownload"
					></audio>
					<video
						class="ability-detail-audio"
						controls
						:src="item.src"
						v-else-if="item.type === 'video'"
						controlslist="noplaybackrate nodownload"
						style="max-height: 500px;"
					></video>
					<img :src="item.src" v-else />
				</div>
			</div>
		</div>
		<div class="top">
			<div class="correct-color-container">
				<div class="correct-color" v-for="(item, index) in correctColor" :key="item">
					<div class="block"></div>
					<div class="plus" v-if="index < correctColor.length - 1">+</div>
				</div>
			</div>

			<div><img src="@/assets/image/color.svg" /></div>
			<div class="final-color" :style="{ background: finalColor }"></div>
		</div>

		<div class="bottom">
			<span>请在上方选择你要填色的区域序号进行填色或查看</span>
			<div class="select-color-container">
				<div
					:style="{ background: item }"
					class="select-color"
					v-for="item in showColors"
					:key="item"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import { blendColors } from '@/utils/blendColors'

function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
}

export default {
	props: {
		filterBody: {
			type: String,
			default: '',
			require: true
		},
		srcResource: {
			type: Array,
			default: () => [],
			require: true
		},
		data: {
			type: Array,
			default: () => {},
			require: true
		}
	},
	computed: {
		correctColor() {
			return this.data[0]
		},
		interfereColor() {
			return this.data[1]
		},
		/** 最终颜色 */
		finalColor() {
			return blendColors(this.correctColor)
		},
		showColors() {
			return shuffleArray(this.data[1].flat(1))
		}
	},

}
</script>

<style lang="scss" scoped>
.top {
	display: flex;
	align-items: center;
}

.correct-color-container {
	display: flex;
	align-items: center;
	.correct-color {
		display: flex;
		align-items: center;
		.block {
			box-sizing: border-box;
			width: 198px;
			height: 199px;
			border-radius: 36px;
			border: 8px solid #d7d7d7;
			margin: 20px;
		}
	}

	.plus {
		display: flex;
		line-height: 1;
		color: #969696;
		font-size: 100px;
		font-weight: 700;
	}
}

.final-color {
	width: 198px;
	height: 199px;
	border-radius: 36px;
	margin: 20px;
}

.match-color-detail {
	padding: 50px;
	img {
		width: 62px;
		height: 62px;
	}

	display: flex;
	flex-direction: column;
	align-items: center;
}

.bottom {
	margin-top: 40px;
	width: 898px;
	height: 161px;
	border-radius: 12px;
	border: 1.5px solid #c6c6c6;
	background: #fff;
	display: flex;
	flex-direction: column;
	justify-content: center;
	box-sizing: border-box;
	padding: 20px;

	.select-color-container {
		display: flex;
		.select-color {
			width: 75px;
			height: 75px;
			border-radius: 11px;
			margin-top: 20px;
			margin-right: 20px;
		}
	}
}

.title {
	color: #3e3e3e;
	font-size: 26px;
	line-height: 41px;
	align-self: flex-start;
}

.ability-detail {
	background: #ffffff;
	border-radius: 8px 8px 8px 8px;
	min-height: inherit;
	overflow: hidden;
	img {
		height: 180px;
	}
	.ability-detail-header {
		display: flex;
		align-items: center;
		font-size: 16px;
		padding: 15px 15px 15px 25px;
		cursor: pointer;
	}
	.ability-detail-header:hover {
		color: #ff5e2a;
	}
	.ability-detail-subheader {
		display: flex;
		justify-content: space-between;
		background: #fbfbfb;
		height: 61px;
		margin-left: 21px;
	}
	.ability-detail-num {
		font-size: 16px;
		font-family: PingFang SC-Medium, PingFang SC;
		font-weight: 500;
		color: #565656;
		margin-right: 7px;
	}
	.ability-detail-id {
		width: 68px;
		height: 27px;
		background: #ebebeb;
		border-radius: 2px 2px 2px 2px;
		margin-right: 21px;
		font-size: 12px;
		font-family: PingFang SC-Medium, PingFang SC;
		font-weight: 500;
		color: #757575;
	}
	.ability-detail-row {
		height: 27px;
		background: #ebebeb;
		border-radius: 2px 2px 2px 2px;
		font-size: 14px;
		font-family: PingFang SC-Medium, PingFang SC;
		font-weight: 500;
		color: #757575;
		padding: 0 14px;
	}
	.ability-detail-total {
		margin-right: 8px;
		font-size: 12px;
		font-family: PingFang SC-Medium, PingFang SC;
		font-weight: 500;
		color: #757575;
	}
	.ability-detail-icon-left {
		width: 31px;
		height: 32px;
		background: #eeeeee;
		margin-right: 5px;
	}
	.button:hover {
		background: #ff5e2a;
		color: #ebebeb;
	}
	.button:focus {
		background: #ff5e2a;
		color: #ebebeb;
	}
	.ability-detail-icon-right {
		width: 31px;
		height: 32px;
		background: #eeeeee;
		// background: #ff5e2a;
		border-radius: 3px 3px 3px 3px;
		margin-right: 8px;
	}
	.ability-detail-button {
		width: 77px;
		height: 32px;
		background: #eeeeee;
		border-radius: 4px 4px 4px 4px;
		margin-right: 8px;
	}
	.ability-detail-body {
		max-width: max-content;
		// 左边对齐
		margin-left: 58px;
		display: flex;
		flex-direction: column;

		// align-items: center;
	}
	.ability-detail-body-title {
		:deep(p) {
			line-height: 1 !important;
			font-size: 24px !important;
		}
		font-size: 24px !important;
		font-family: PingFang SC-Bold, PingFang SC;
		font-weight: bold;
		color: #3e3e3e;
		margin-top: 40px;
		margin-bottom: 10px;
		margin-right: 58px;
		// max-width: 696px;
		min-width: 400px;
		display: flex;
		flex-wrap: wrap;
		align-items: baseline;
		// justify-content: center;
	}
	.ability-detail-resource {
		margin-bottom: 20px;
	}
	.gird {
		display: grid;
		grid-template-columns: 1fr 1fr;
		grid-column-gap: 60px;
		max-width: 1080px;
	}
	.ability-detail-radio {
		// max-width: 696px;
		max-width: 500px;
		min-width: 400px;
		border-radius: 6px 6px 6px 6px;
		border: 1px solid #ffd4c6;
		display: flex;
		align-items: center;
		padding: 22px 10px;
		margin-bottom: 30px;
		overflow: hidden;
		.radio-item {
			display: flex;
			align-items: center;
			margin-left: 10px;
			flex: 1;
			max-height: 150px;
			overflow: auto;
		}
	}
	.ability-detail-radio-active {
		border: 1px solid #ff5e2a !important;
	}
	.ability-detail-audio {
		height: 180px;
	}
}
</style>
